import {
    VENDOR_JOB_UPDATE_REQUEST,
    VENDOR_JOB_UPDATE_SUCCESS,
    VENDOR_JOB_UPDATE_FAIL
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: null,
    msg: "",
    error: "",
  };
  
  const VendorJobUpdateReducer = (state = initialState, action) => {
    switch (action.type) {
      case VENDOR_JOB_UPDATE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case VENDOR_JOB_UPDATE_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: false,
          msg: action.msg,
        };
      case VENDOR_JOB_UPDATE_FAIL:
        return {
          ...state,
          error: action.error,
          loading: false,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default VendorJobUpdateReducer;
  